<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div class="m3">
        <div v-if="store.state.contacts.length <= 1" class="p3 white-bg flex my3">
          <span class="flex flex-auto h5n semi-bold justify-center">Aucun participant n’est saisi</span>
        </div>
        <div v-for="(contact, index) in store.state.contacts.filter(c => c.uuid !== store.state.user.uuid)" v-else :key="index" class="py1 white-bg my3">
          <div class="col-12 flex flex-wrap py1">
            <div class="col-12 flex flex-column items-center">
              <span class="blue h3n bold center">{{ contact.firstname }} {{ contact.lastname }}</span>
              <p class="h3n semi-bold center blue m0">{{ genderVocabulary(contact.gender) }} le {{ contact.birth_date }}</p>
            </div>
            <div class="col-12 flex flex-wrap justify-center">
              <Button text="Modifier" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="white" :action="editContact.bind(this, contact.uuid)" />
              <!-- <Button text="Retirer" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="red" icon-left="icon-trash" :action="toggleDeletingParticipant.bind(this, contact.uuid)" /> -->
            </div>

            <!-- <div v-else class="col-12 flex flex-wrap justify-center">
              <p class="col-12 center">Voulez-vous vraiment supprimer votre participant?</p>

              <Button text="Annuler" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="white" :action="toggleDeletingParticipant.bind(this, contact.uuid)" />
              <Button text="Confirmer" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="white" :action="removeParticipant.bind(this, contact.uuid)" />
            </div> -->
          </div>
        </div>

        <!-- <div class="flex flex-wrap justify-center">
          <Button text="Ajouter" class="col-8 md-col-6 lg-col-4 mb3" btn-color="inverted" :action="addNewContact" />
        </div> -->
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>

import { getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Button from '@/components/elements/Button';
import { genderVocabulary, routeIsCurrentComponent, isInImpersonateModeNotification} from '@/mixins/utils';
// import { disassociateParticipant } from '@/mixins/requests';

export default {
  components: { Button },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());
    // const deletingParticipant = ref({});

    // const addNewContact = () => {
    //   if (isInImpersonateModeNotification()) {
    //     return;
    //   }
    //   router.push({ name: 'AddContact' })
    // };
    const editContact = uuid => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      router.push({ name: 'EditContact', params: { uuid } })
    };

    // const removeParticipant = async participant => {
    //   store.commit('setLoading', true);

    //   const data = { participant: participant, user: store.state.user, contacts: store.state.contacts };

    //   await disassociateParticipant(data);

    //   store.commit('setLoading', false);
    // };

    // const toggleDeletingParticipant = uuid => { deletingParticipant.value[uuid] = !deletingParticipant.value[uuid]; };

    return { route, store, editContact, genderVocabulary, routeMatchesComponent /* addNewContact, removeParticipant, deletingParticipant, toggleDeletingParticipant */ };
  }
};
</script>

<style>

</style>
